import { render, staticRenderFns } from "./StakingFillIcon.vue?vue&type=template&id=aa78c050&scoped=true&"
import script from "./StakingFillIcon.vue?vue&type=script&lang=js&"
export * from "./StakingFillIcon.vue?vue&type=script&lang=js&"
import style0 from "./StakingFillIcon.vue?vue&type=style&index=0&id=aa78c050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa78c050",
  null
  
)

export default component.exports